/**
 * Temas usados para cada página
 */
export const themes = {
  colorBarra: '#2abda7',
  opacity: 'rgba(255,255,255,.25)',
  actColor: '#FFCA1C',
  antColor: '#003057',
  antAntColor: '#DE0424',
  actColorSecondary: '#FFD01C4D',
  antColorSecondary: '#1641924D',
  antAntColorSecondary: '#E404244D',
  default: {
    c: '#7d7c7c',
    cs: '#bdbbbb',
  },
  inicio: {
    color: '#00A4A0', //'rgb(0,164,160)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(0,164,160,.5)',
    search: {
      background: 'rgba(255,255,255,.25)',
    },
    base: '#164192',
    backgroundColor: '#f5f8fd',
  },
  tarjetasInicio: {
    linkBtn: '#2769EA',
  },
  tarjetasCandidaturas: {
    backgroundColor: '#f9fafe',
    textColor: '#174292',
  },
  color: {
    sinInfo: '#ccc',
    noSeCelebra: '#888',
    coloresEmpate: ['#f5ad00', '#ccc'],
  },
  mesasInformadas: {
    colorBarra: '#f00',
  },
};
